var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-slide" }, [
    _c("div", { staticClass: "header-info-main" }, [
      _c("div", { staticClass: "logo" }, [
        _c("img", {
          staticStyle: { height: "45px", width: "45px" },
          attrs: { src: _vm.PictureUrl }
        })
      ]),
      _c("div", { staticClass: "header-info" }, [
        _c("h4", [
          _vm._v(_vm._s(_vm.SectionName) + " | " + _vm._s(_vm.SubSectionName))
        ]),
        _c("p", [_vm._v(_vm._s(_vm.Description))])
      ])
    ]),
    _c("div", { staticClass: "type_reseau" }, [
      _c("i", { class: _vm.iconNetwork[_vm.Network] }),
      _vm._v("\n        " + _vm._s(_vm.Network) + "\n    ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }